/**
 * Microsoft Entra ID (Azure AD) settings.
 * Authorization Code + PKCE is the default browser flow in @azure/msal-browser.
 * Do not switch this app to the implicit flow.
 */

const NIL_CLIENT_ID = "00000000-0000-0000-0000-000000000000";

function appOrigin() {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.origin;
}

export function getAzureClientId() {
  return (process.env.REACT_APP_AZURE_CLIENT_ID || "").trim();
}

export function getAzureAuthority() {
  const authority = (process.env.REACT_APP_AZURE_AUTHORITY || "").trim();
  if (authority) {
    return authority.replace(/\/$/, "");
  }

  const tenantId = (process.env.REACT_APP_AZURE_TENANT_ID || "").trim();
  if (tenantId) {
    return `https://login.microsoftonline.com/${tenantId}`;
  }

  return "";
}

export function getAzureRedirectUri() {
  const configured = (process.env.REACT_APP_AZURE_REDIRECT_URI || "").trim();
  if (configured) {
    return configured;
  }
  const origin = appOrigin();
  return origin ? `${origin}/login` : "";
}

export function getAzureApiScopes() {
  const raw = process.env.REACT_APP_AZURE_API_SCOPE || "";
  return raw
    .split(/[\s,]+/)
    .map((scope) => scope.trim())
    .filter(Boolean);
}

export function isMicrosoftAuthConfigured() {
  return Boolean(
    getAzureClientId() && getAzureAuthority() && getAzureApiScopes().length
  );
}

export function getMsalConfig() {
  const origin = appOrigin();
  const redirectUri = getAzureRedirectUri() || (origin ? `${origin}/login` : "/login");

  return {
    auth: {
      clientId: getAzureClientId() || NIL_CLIENT_ID,
      authority: getAzureAuthority() || "https://login.microsoftonline.com/common",
      redirectUri,
      postLogoutRedirectUri: redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      // Keep MSAL cache out of long-lived localStorage; app session uses Django JWTs.
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      allowNativeBroker: false,
    },
  };
}

export function getLoginRequest(options = {}) {
  const request = {
    scopes: getAzureApiScopes(),
    prompt: "select_account",
  };

  const loginHint = (options.loginHint || "").trim();
  if (loginHint) {
    request.loginHint = loginHint;
  }

  return request;
}

export function getTokenRequest(account) {
  return {
    scopes: getAzureApiScopes(),
    account,
  };
}
